export default "__VITE_ASSET__BQYKyycb__"